

import { createApp } from "vue";
import App from "@/App.vue";
import { createPinia } from "pinia";
import router from "@/router";
import { CommonComponentBundle } from "@energielenker/common-component-bundle";
import i18n from "@/i18n";
import "@/assets/main.css";
import "@/assets/base.scss";
import { initializeLanguage } from "@/constants/languages";
import { initializeFeatureFlags } from '@/utils/featureFlags';
import toast, { POSITION } from "vue-toastification";
import "vue-toastification/dist/index.css";
import * as Sentry from "@sentry/vue";
import '@/registerServiceWorker';
// import { useCapacitorPushNotifications } from '@/composables/usePushNotifications';

import { Capacitor } from '@capacitor/core';
// import { Keyboard } from '@capacitor/keyboard';
import { SplashScreen } from '@capacitor/splash-screen';

// if ('serviceWorker' in navigator) {
//   navigator.serviceWorker.register('/service-worker.js')
//     .then(() => console.log('registered servicve worker'))
//     .catch(err => console.error('SW registration failed:', err));
// }


// if (Capacitor.getPlatform() !== 'web') {
//   console.log("Capacitor detected - initializing push notifications");
//   // alert("Capacitor detected - initializing push notifications");
//   useCapacitorPushNotifications();
// }

if (process.env.NODE_ENV === 'production') {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const noop = () => {};
  console.log = noop;
  console.warn = noop;
  console.error = noop;
  console.info = noop;
  console.debug = noop;
}

if (process.env.NODE_ENV !== 'production' && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      if (registration.scope.includes('energielenker')) {
        registration.unregister();
      }
    });
  });
}


// remove console warnings for featureToggle.isVisible
(() => {
  const originalWarn = console.warn;
  console.log = (...args: any[]) => {
    if (args.some(arg => typeof arg === 'string' && arg.includes('featureToggle.isVisible'))) return;
    originalWarn(...args);
  };
})();

const pinia = createPinia();

const app = createApp(App);

Sentry.init({
  app,
  dsn: "https://c532df4b0f7882e55703d2b35e9b285b@sentry.m.elmonitor.de/13"
});

initializeLanguage(pinia, i18n);
initializeFeatureFlags();

app.use(toast, {
  position: POSITION.TOP_CENTER,
  timeout: 3000,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  hideProgressBar: false,
});



app
  .use(router)
  .use(pinia)
  .use(CommonComponentBundle, {})
  .use(i18n)
  .mount("#app");

router.isReady().then(async () => {
  if (Capacitor.isNativePlatform()) {
    await SplashScreen.hide({
      fadeOutDuration: 500
    });
  }
});


